import { useEffect, useRef } from "react";
import Container from "../../../component/container/Container";
import ApiConnectionModule from "../../../component/form/api-connection-module/ApiConnectionModule";
import SortableTable, {
  SortSettings,
} from "../../../component/sortable-table/SortableTable";
import "./ApiDashboard.scss";

interface ApiDashboardPageProps {
  headerLine: string[];
  content: any[][];
  sortSettings: SortSettings | undefined;
  searchParam: string;

  changeSortAction: (col: number) => void;
  changeSearchParam: (val: string) => void;

  selectedConnectionId?: any;
  clientName?: string;
  applicationId?: string;
  weightronUid?: string;
  collectionId?: string;
  weightronSecret?: string;
  weightronApiKey?: string;
  endpointUrl?: string;
  connectionInProgress: boolean;
  submissionInProgress: boolean;
  invalidWeightronUid?: string;
  invalidWeightronSecret?: string;
  invalidWeightronApiKey?: string;
  invalidEndpointUrl?: string;
  isSuccess?: boolean;
  submitMsg?: string;
  isTestingConnection?: any;
  setClientName: (name: string) => void;
  setApplicationId: (ids: string) => void;
  setWeightronUid: (uid: string) => void;
  setCollectionId: (id: string) => void;
  setWeightronSecret: (secret: string) => void;
  setWeightronApiKey: (key: string) => void;
  setEndpointUrl?: (url: string) => void;
  onEvaluateConnection: (id?: any) => void;
  onSave: () => void;
  resetInvalidMsg: () => void;
  onOpenEditConnection: (id: any) => void;
  onConfirmDeleteConnection: (id: any) => void;
  onDeleteConnection: (id: any) => void;
  setOpenDeleteDialog: (open: boolean) => void;
  setOpenedTestConnectionDialog: (open: boolean) => void;

  width: number;
  darkMode: boolean;
  openEditConnection?: boolean;
  openDeleteDialog: boolean;
  openTestConnectionDialog: boolean;
}

const ApiDashboardPageUI = (props: ApiDashboardPageProps) => {
  const deleteDialogRef = useRef<HTMLDialogElement>(null);
  const testConnectionDialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    if (props.openDeleteDialog) {
      deleteDialogRef.current?.showModal();
    } else {
      deleteDialogRef.current?.close();
    }
  }, [props.openDeleteDialog]);

  useEffect(() => {
    if (props.openTestConnectionDialog) {
      testConnectionDialogRef.current?.showModal();
    } else {
      testConnectionDialogRef.current?.close();
    }
  }, [props.openTestConnectionDialog]);

  return (
    <>
      <div
        className={"api-dashboard-wrapper" + (props.darkMode ? " dark" : "")}
      >
        {props.openEditConnection && (
          <div>
            <ApiConnectionModule
              clientName={props.clientName ?? ""}
              applicationId={props.applicationId ?? ""}
              weightronUid={props.weightronUid ?? ""}
              collectionId={props.collectionId ?? ""}
              weightronSecret={props.weightronSecret ?? ""}
              weightronApiKey={props.weightronApiKey ?? ""}
              endpointUrl={props.endpointUrl ?? ""}
              connectionInProgress={props.connectionInProgress}
              submissionInProgress={props.submissionInProgress}
              invalidWeightronUid={props.invalidWeightronUid}
              invalidWeightronSecret={props.invalidWeightronSecret}
              invalidWeightronApiKey={props.invalidWeightronApiKey}
              invalidEndpointUrl={props.invalidEndpointUrl}
              isSuccess={props.isSuccess}
              submitMsg={props.submitMsg}
              setClientName={props.setClientName}
              setApplicationId={props.setApplicationId}
              setWeightronUid={props.setWeightronUid}
              setCollectionId={props.setCollectionId}
              setWeightronSecret={props.setWeightronSecret}
              setWeightronApiKey={props.setWeightronApiKey}
              setEndpointUrl={props.setEndpointUrl}
              onEvaluateConnection={props.onEvaluateConnection}
              onSave={props.onSave}
              resetInvalidMsg={props.resetInvalidMsg}
              darkMode={props.darkMode}
              editMode
            />
          </div>
        )}
        <Container darkTheme={props.darkMode}>
          <div className="column">
            <SortableTable
              id="weightron-api-list"
              width={props.width}
              header={props.headerLine}
              data={props.content}
              standaloneTable
              isWeightingTable
              isTestingConnection={props.isTestingConnection}
              currentSort={props.sortSettings}
              onSortChanged={props.changeSortAction}
              currentFilterKey={props.searchParam}
              onFilterChanged={props.changeSearchParam}
              rowsPerPage={25}
              darkMode={props.darkMode}
              sourceDownload="local"
              testConnection={(id) => props.onEvaluateConnection(id)}
              editApi={(id) => props.onOpenEditConnection(id)}
              deleteApi={(id) => props.onConfirmDeleteConnection(id)}
            />
          </div>
        </Container>
      </div>
      <dialog
        ref={deleteDialogRef}
        className={"connection-dialog" + (props.darkMode ? " dark" : "")}
      >
        <div className="dialog-content">
          <h3>Delete Connection</h3>
          <p>Are you sure you want to delete this connection?</p>
          <div className="btn-array">
            <button
              className="btn btn-secondary"
              onClick={() => props.setOpenDeleteDialog(false)}
            >
              Cancel
            </button>
            <button
              className="btn btn-danger"
              onClick={() =>
                props.onDeleteConnection(props.selectedConnectionId)
              }
            >
              Delete
            </button>
          </div>
        </div>
      </dialog>
      <dialog
        ref={testConnectionDialogRef}
        className={"connection-dialog" + (props.darkMode ? " dark" : "")}
      >
        <div className="dialog-content">
          <h3>Test Connection</h3>
          <p>{props.submitMsg}</p>
          <div className="btn-array">
            <button
              className="btn btn-secondary"
              onClick={() => props.setOpenedTestConnectionDialog(false)}
            >
              Close
            </button>
          </div>
        </div>
      </dialog>
    </>
  );
};

export default ApiDashboardPageUI;
